module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate25.457245b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate25.png
// module id = 761
// module chunks = 0